import { Link } from 'react-router-dom';
import { CheckSquare, Square, Undo2 } from 'lucide-react';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');

/** One recalled batch on the till checklist: tick as pulled, then it waits for the supplier return. */
export const TillRecallRow = ({ item, batch, online, busy, onPull, onUndo }) => {
  const id = `${item.product_id}-${batch.batch_number || 'all'}`;
  const pulled = batch.pulled;
  return (
    <li className="flex flex-wrap items-center justify-between gap-2 px-3 py-2" data-testid={`till-recall-item-${id}`}>
      <span className="flex items-center gap-2 min-w-0">
        <button
          type="button" disabled={busy || !!pulled} onClick={() => onPull(item, batch)}
          aria-label={pulled ? 'Pulled from shelf' : `Mark ${item.name} as pulled`}
          className="shrink-0 text-red-700 disabled:cursor-default" data-testid={`till-recall-pull-${id}`}
        >
          {pulled ? <CheckSquare className="h-5 w-5 text-emerald-600" /> : <Square className="h-5 w-5" />}
        </button>
        <span className="min-w-0">
          <span className="font-medium">{item.name}</span>
          <span className="text-red-700"> · {batch.batch_number || 'All batches'}</span>
          {pulled && (
            <span className="block text-xs text-emerald-800" data-testid={`till-recall-pulled-${id}`}>
              Pulled, awaiting return · {pulled.pulled_by_name || 'Staff'}{pulled.pulled_at ? ` · ${fmt(pulled.pulled_at)}` : ''}
              {pulled.pending && ' · syncs when online'}
            </span>
          )}
        </span>
      </span>
      <span className="flex items-center gap-3">
        <span className="font-semibold tabular-nums" data-testid={`till-recall-units-${id}`}>{batch.quantity} on shelf</span>
        {pulled?.pull_id && online && (
          <button type="button" onClick={() => onUndo(pulled.pull_id)} className="text-xs underline inline-flex items-center gap-1" data-testid={`till-recall-undo-${id}`}>
            <Undo2 className="h-3 w-3" /> Undo
          </button>
        )}
        <Link to={`/inventory/${item.product_id}`} className="text-xs font-medium underline" data-testid={`till-recall-return-link-${id}`}>Log return</Link>
      </span>
    </li>
  );
};
